import { cn } from '@/lib/utils';
import { GrainMarkIcon } from '../icons/primitives';

interface AccessLevelCardProps {
  /** Product the access applies to. "Grain Portal" until users carry a team. */
  product: string;
  /** Canonical role label, from `users.roles.*`. */
  role: string;
  /** Spacing is the caller's — the card sits differently on each surface. */
  className?: string;
}

/** Shared by the account page and the users preview drawer. */
export function AccessLevelCard({ product, role, className }: AccessLevelCardProps) {
  return (
    <div
      className={cn(
        'flex w-full max-w-[260px] items-center gap-4 rounded-input border border-dinnerplate-white bg-off-white p-6 shadow-[0_0_20px_3px_#EFEFEF80]',
        className,
      )}
    >
      <div className="flex size-12 shrink-0 items-center justify-center rounded-full bg-off-black">
        <GrainMarkIcon aria-hidden="true" className="h-5 w-auto shrink-0 text-white" />
      </div>
      <div className="flex flex-col gap-1">
        <p className="font-inter text-sm font-semibold text-off-black">{product}</p>
        <p className="font-inter text-xs text-grey">{role}</p>
      </div>
    </div>
  );
}
